module.exports = __webpack_public_path__ + "img/MarketingNew.469bed7d.png";